import {post} from '../service/uploadfetch';

/**
 *  图片上传
 * @param data
 * @returns {*}
 */
export const imageUpload = (data, config) => post(`${process.env.BASE_API}/message/post/image`, data, config);

/**
 *  图片下载
 * @param data
 * @returns {*}
 */
export const imageDownload = (data) => post(`${process.env.BASE_API}/v1/online/image/download`, data);



// WEBPACK FOOTER //
// ./src/service/uploadService.js